export class GalleryPhotosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getGalleryPhotos(filter) {
    return this.instance.get('/v1/gallery-photos', {
      params: filter || null,
    });
  }

  getGalleryPhotosThumbnailsMap(params) {
    return this.instance.get('/v1/gallery-photos/thumbnails-map', {
      params: params || undefined,
    });
  }

  addGalleryPhoto(formData) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.instance.post('/v1/gallery-photos', formData, config);
  }

  deleteGalleryPhoto(id) {
    return this.instance.delete(`/v1/gallery-photos/${id}`);
  }
}

export default (...params) => new GalleryPhotosFactory(...params);

